var path = 'app/scripts/modules/core/src/serverGroup/configure/common/costFactor.html';
var html = "<span class=\"cost-factor\" ng-if=\"!range\">\n  <span class=\"cost\">{{used}}</span>{{unused}}\n</span>\n<span class=\"cost-factor\" ng-if=\"range\">\n  <span class=\"cost\">{{min.used}}</span>{{min.unused}}\n  &ndash;\n  <span class=\"cost\">{{max.used}}</span>{{max.unused}}\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/serverGroup/configure/common/costFactor.html
// module id = 1078
// module chunks = 0